var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.entry)?_c('div',[_c('div',{staticClass:"readonly-wrapper",staticStyle:{"max-width":"400px"}},[_c('div',{staticClass:"readonly-wrapper__label"},[_vm._v(_vm._s(_vm.$t(_vm.entry.name)))]),_c('div',{staticClass:"readonly-wrapper__value d-flex flex-wrap"},[_vm._v(" "+_vm._s(this.displayvalue)+" ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }